// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"921f8486","453":"5678ce78","455":"791be4a6","977":"b354189c"}[chunkId] + ".chunk.js";
};